export default "__VITE_ASSET__CfFqWiA0__"